module.exports = __webpack_public_path__ + "static/media/han-taste-bg1.6bf6fe38.png";